import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import MUITableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

class TableHead extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    rowProps: PropTypes.object,
    staticContext: PropTypes.any,
  };

  render() {
    let { children, rowProps, staticContext, ...props } = this.props;

    return (
      <MUITableHead {...props}>
        <TableRow {...rowProps}>{children}</TableRow>
      </MUITableHead>
    );
  }
}

TableHead.skpName = 'TableHeader';

export default TableHead;
